import { useCallback } from 'react';
import { PreloadImage } from '~/components/preload-image';

function getIndicatorsAlignmentClassName(alignment: string) {
  switch (alignment) {
    case 'left':
      return 'self-start';
    case 'right':
      return 'self-end';
    case 'center':
    default:
      return 'self-center';
  }
}

function HorizontalListIndicators({
  entries,
  alignment,
  position,
  arrowsSwitch,
  arrowLeftAsset,
  arrowRightAsset,
  circularCondition,
  currentIndicatorsIndex,
  onIndicatorUpdate,
  onLeftArrowPress,
  onRightArrowPress,
  show,
  uiComponentId,
}: {
  entries: Array<any>;
  alignment: string;
  position: string;
  arrowsSwitch?: boolean;
  arrowLeftAsset?: string;
  arrowRightAsset?: string;
  circularCondition: boolean;
  currentIndicatorsIndex: number;
  onIndicatorUpdate: (index: number) => void;
  onLeftArrowPress: () => void;
  onRightArrowPress: () => void;
  show: boolean;
  uiComponentId: string;
}) {
  const onIndicatorPress = useCallback(
    (i: number) => () => {
      onIndicatorUpdate(i);
    },
    [onIndicatorUpdate]
  );

  if (!show) return <></>;

  const leftArrowDisabled: boolean =
    currentIndicatorsIndex === 0 && !circularCondition;
  const rightArrowDisabled: boolean =
    currentIndicatorsIndex === entries?.length - 1 && !circularCondition;

  return (
    <div
      className={`z-[10] flex w-fit items-center rounded-horizontal-list-indicators border-horizontal-list-indicators-width border-horizontal-list-indicators-color bg-horizontal-list-indicators pb-horizontal-list-indicators-b pl-horizontal-list-indicators-l pr-horizontal-list-indicators-r pt-horizontal-list-indicators-t ${getIndicatorsAlignmentClassName(
        alignment
      )} ${
        position === 'top'
          ? 'horizontal-list-indicators-top-position'
          : 'horizontal-list-indicators-margin'
      }`}
    >
      {arrowsSwitch && arrowLeftAsset && (
        <>
          <PreloadImage tailwindImageClass="horizontal-list-indicator-arrow-left-asset" />
          <PreloadImage tailwindImageClass="horizontal-list-indicator-arrow-left-asset-inactive" />
          <PreloadImage tailwindImageClass="horizontal-list-indicator-arrow-left-asset-hover" />
          <button
            onClick={onLeftArrowPress}
            disabled={leftArrowDisabled}
            data-testid={`horizontal-list-indicators-left-arrow-${uiComponentId}`}
            className={`mb-horizontal-list-indicator-arrow-left-b ml-horizontal-list-indicator-arrow-left-l mr-horizontal-list-indicator-arrow-left-r mt-horizontal-list-indicator-arrow-left-t h-horizontal-list-indicator-arrow w-horizontal-list-indicator-arrow bg-horizontal-list-indicator-arrow-left-asset bg-contain bg-center bg-no-repeat ${
              leftArrowDisabled
                ? 'bg-horizontal-list-indicator-arrow-left-asset-inactive'
                : 'hover:bg-horizontal-list-indicator-arrow-left-asset-hover'
            }`}
          />
        </>
      )}
      <div className="flex gap-horizontal-list-indicators">
        {entries?.map((entry, i) => {
          return (
            <button
              key={entry?._key}
              onClick={onIndicatorPress(i)}
              className={`${
                currentIndicatorsIndex === i
                  ? 'border-horizontal-list-indicator-color-selected bg-horizontal-list-indicator-selected hover:border-horizontal-list-indicator-color-selected-hover'
                  : ''
              } h-horizontal-list-indicators w-horizontal-list-indicators rounded-horizontal-list-indicator border-horizontal-list-indicator-width border-horizontal-list-indicator-color bg-horizontal-list-indicator hover:border-horizontal-list-indicator-color-hover hover:bg-horizontal-list-indicator-hover
          `}
            />
          );
        })}
      </div>
      {arrowsSwitch && arrowRightAsset && (
        <>
          <PreloadImage tailwindImageClass="horizontal-list-indicator-arrow-right-asset" />
          <PreloadImage tailwindImageClass="horizontal-list-indicator-arrow-right-asset-hover" />
          <PreloadImage tailwindImageClass="horizontal-list-indicator-arrow-right-asset-inactive" />
          <button
            onClick={onRightArrowPress}
            disabled={rightArrowDisabled}
            data-testid={`horizontal-list-indicators-right-arrow-${uiComponentId}`}
            className={`mb-horizontal-list-indicator-arrow-right-b ml-horizontal-list-indicator-arrow-right-l mr-horizontal-list-indicator-arrow-right-r mt-horizontal-list-indicator-arrow-right-t h-horizontal-list-indicator-arrow w-horizontal-list-indicator-arrow bg-horizontal-list-indicator-arrow-right-asset bg-contain bg-center bg-no-repeat ${
              rightArrowDisabled
                ? 'bg-horizontal-list-indicator-arrow-right-asset-inactive'
                : 'hover:bg-horizontal-list-indicator-arrow-right-asset-hover'
            }`}
          />
        </>
      )}
    </div>
  );
}

export default HorizontalListIndicators;
